import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { getDynamicTitleByLocale } from '../../helpers/getDynamicTitle';
import { api, contentPageUploadDir } from '../../config';
import r from 'quill/dist/quill.snow.css';
import s from './ContentPage.css';
import t from '../../styles/customQuillEditor.css'


class ContentPage extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    render() {
        const { title, data, currentLocale } = this.props;
        let addClass = 'ql-editor frontend', content, dynamicContent;

        dynamicContent = getDynamicTitleByLocale({ dynamicHomePageSettings: data?.dynamicContent, locale: currentLocale })
        content = dynamicContent[0]?.content || data?.content;

        return (
            <div className='contentPageWrapper'>
                {
                    data && data.pageBanner && <div
                        className={s.contentPageTopBgImg}
                        style={{ backgroundImage: `url(${api.apiEndpoint + contentPageUploadDir + data.pageBanner})` }} />
                }
                <div className={s.contentPageInfoContainer}>
                    <div className={addClass} dangerouslySetInnerHTML={{ __html: content || '' }} />
                </div>
            </div>
        )
    }
}
const mapState = (state) => ({
    currentLocale: state?.intl?.locale
})
const mapDispatch = {};

export default withStyles(r, s, t)(connect(mapState, mapDispatch)(ContentPage));